import React from "react";
import { Link } from "react-router-dom";
class Card extends React.Component {

    componentDidMount() {

    }

  render() {

    return (
      <div className="rob-card">
          <div className="rob-card__img" style={{backgroundImage: `url(${this.props.imageUrl})`}}></div>
          <div className="rob-card__date">{this.props.date}</div>
          <div className="rob-card__title">{this.props.title}</div>
          <Link to={this.props.url} className="rob-card__button"> Read More</Link>

      </div>
    )
  }
}

export default Card;




// WEBPACK FOOTER //
// ./src/components/elements/Card.js